import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './auth/auth.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { PreAuthPagesModule } from './pages/pre-auth-pages/pre-auth-pages.module';
import { SharedModule } from './shared/shared.module';
import { I18nModule } from './i18n/i18n.module';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    PreAuthPagesModule,
    SharedModule,
    I18nModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    providePrimeNG({ theme: { preset: Aura } })
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
